
import ImagePreview from './ImagePreview.vue'
import Vue from 'vue'

ImagePreview.newInstance = (props = {}) => {
  const Instance = new Vue({
    data: props,
    render(h) {
      return h(ImagePreview, {
        props
      })
    }
  })
  const component = Instance.$mount()
  document.body.appendChild(component.$el)
  const preview = Instance.$children[0]

  return {
    open: preview.open
  }
}

let previewInstance

function getPreviewInstance() {
  previewInstance = previewInstance || ImagePreview.newInstance();
  return previewInstance;
}

export default getPreviewInstance

